import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GCADASharedModule } from '@GCADA/shared.module';

import { ContentComponent } from 'app/layout/components/content/content.component';

@NgModule({
    declarations: [
        ContentComponent
    ],
    imports     : [
        RouterModule,
        GCADASharedModule
    ],
    exports     : [
        ContentComponent
    ]
})
export class ContentModule
{
}
